<template>
  <a-drawer width="60%" :visible="open" @close="onClose" :title="formTitle">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <!-- 可编辑字段：直播主题 -->
      <a-form-model-item prop="theme" >
        <span slot="label" >
        <a-tooltip>
        {{$t('直播主题')}}<template slot="title">{{$t('直播主题')}}</template>
        </a-tooltip>
        </span>
        <a-input v-model="form.theme" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('直播主题')"/>
      </a-form-model-item>

      <!-- 可编辑字段：地址（新增页面地址本身也是可编辑的，保持一致放开） -->
      <a-form-model-item prop="liveAddress" >
        <span slot="label" >
          <a-tooltip>
            {{$t('地址')}}<template slot="title">{{$t('地址')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.liveAddress" :placeholder="$t('通用.输入.请输入')+$t('地址')" />
      </a-form-model-item>

      <!-- 只读：直播预计开启时间 -->
      <a-form-model-item prop="preOpenTime" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播预计开启时间')}}<template slot="title">{{$t('直播预计开启时间')}}</template>
          </a-tooltip>
        </span>
        <a-input :value="form.preOpenTime ? parseTime(form.preOpenTime) : '-'" disabled />
      </a-form-model-item>

      <a-row :gutter="48">
        <a-col :md="12" :sm="24">
          <!-- 可编辑字段：直播封面 -->
          <a-form-model-item :label="this.$t('直播封面')" prop="thumb">
            <a-upload
              name="thumb"
              listType="picture-card"
              :multiple="false"
              :show-upload-list="false"
              :before-upload="beforeOssUpload"
              :customRequest="coverImgUpload">
              <img
                v-if="form.thumb"
                :src="form.thumb"
                alt="picture"
                style="height: 100px; width: 100px;"/>
              <div v-else>
                <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
              </div>
            </a-upload>
            <span>推荐尺寸 100 x 100</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <!-- 只读：分享直播封面 -->
          <a-form-model-item :label="this.$t('分享直播封面')" prop="sharePic">
            <a-avatar v-if="form.sharePic" shape="square" :size="100" :src="form.sharePic" />
            <span v-else>-</span>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 只读：直播类型 -->
      <a-form-model-item prop="liveType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('直播类型')}}<template slot="title">{{$t('直播类型')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.liveType" placeholder="请选择类型" disabled>
          <a-select-option v-for="(item, index) in liveTypeList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 只读：屏幕模式 -->
      <a-form-model-item prop="screenMode" >
        <span slot="label" >
          <a-tooltip>
            {{$t('屏幕模式')}}<template slot="title">{{$t('屏幕模式')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.screenMode" placeholder="请选择类型" disabled>
          <a-select-option v-for="(item, index) in screenModeList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 只读：允许开播用户 -->
      <a-form-model-item prop="allowUserId" v-if="form.liveType==2">
        <span slot="label" >
          <a-tooltip>
            {{$t('允许开播用户')}}<template slot="title">{{$t('允许开播用户')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.allowUserId" placeholder="请选择用户" disabled>
          <a-select-option v-for="(item, index) in userList" :value="item.id" :key="index">
            {{ item.nickName+' '+item.mobile }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 只读：管理员 -->
      <a-form-model-item prop="manageUserId"  v-if="form.liveType==3">
        <span slot="label" >
          <a-tooltip>
            {{$t('管理员')}}<template slot="title">{{$t('管理员')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.manageUserId" placeholder="请选择用户" disabled>
          <a-select-option v-for="(item, index) in userList"  :value="item.id" :key="index">
            {{ item.nickName+' '+item.mobile }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 只读：是否可以回放 -->
      <a-form-model-item prop="isPlayback" >
        <span slot="label" >
          <a-tooltip>
            {{$t('是否可以回放')}}<template slot="title">{{$t('是否可以回放')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.isPlayback" placeholder="请选择" disabled>
          <a-select-option v-for="(item, index) in signList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 只读：是否可以签到 -->
      <a-form-model-item prop="showSignFlag" >
        <span slot="label" >
          <a-tooltip>
            {{$t('是否可以签到')}}<template slot="title">{{$t('是否可以签到')}}</template>
          </a-tooltip>
        </span>
        <a-select :value="form.showSignFlag" placeholder="请选择" disabled>
          <a-select-option v-for="(item, index) in signList" :value="item.value" :key="index">
            {{ item.label}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 只读：签到获取积分 -->
      <a-form-model-item prop="pubSignNum" v-if="form.showSignFlag==1 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('签到获取积分')}}<template slot="title">{{$t('签到获取积分')}}</template>
        </a-tooltip>
        </span>
        <a-input :value="form.pubSignNum" disabled />
      </a-form-model-item>
      <!-- 只读：观看多长时间可签到（分钟） -->
      <a-form-model-item prop="pubSignTime" v-if="form.showSignFlag==1 ">
        <span slot="label" >
        <a-tooltip>
        {{$t('观看多长时间可签到（分钟）')}}<template slot="title">{{$t('观看多长时间可签到（分钟）')}}</template>
        </a-tooltip>
        </span>
        <a-input :value="form.pubSignTime" disabled />
      </a-form-model-item>

      <!-- 只读：观看直播回执（分钟） -->
      <a-form-model-item prop="receiptTime" >
        <span slot="label" >
        <a-tooltip>
        {{$t('观看直播回执（分钟）')}}<template slot="title">{{$t('观看直播回执（分钟）')}}</template>
        </a-tooltip>
        </span>
        <a-input :value="form.receiptTime" disabled />
      </a-form-model-item>
      <!-- 只读：直播确认弹窗倒计时(秒) -->
      <a-form-model-item prop="receiptEffectiveTime" v-if="form.receiptTime&&form.receiptTime>0">
        <span slot="label" >
        <a-tooltip>
        {{$t('直播确认弹窗倒计时(秒)')}}<template slot="title">{{$t('直播确认弹窗倒计时(秒)')}}</template>
        </a-tooltip>
        </span>
        <a-input :value="form.receiptEffectiveTime" disabled />
      </a-form-model-item>

      <!-- 只读：密码 -->
      <a-form-model-item prop="password" >
        <span slot="label" >
        <a-tooltip>
        {{$t('密码')}}<template slot="title">{{$t('密码')}}</template>
        </a-tooltip>
        </span>
        <a-input :value="form.password " :placeholder="$t('通用.输入.请输入')+$t('直播密码')" disabled />
      </a-form-model-item>






      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getLive, updateLive, updateLive1, userList} from '@/api/live/live'
import { generateFilePath, uploadObject, uploadOss } from '@/api/tool/oss'

export default {
  name: 'EditLiveTheme',
  data () {
    return {
      liveTypeList: [
        { value: 2, label: this.$t('视频直播') },
        { value: 3, label: this.$t('obs直播') }
      ],
      screenModeList: [
        { value: 1, label: this.$t('竖屏') },
        { value: 2, label: this.$t('横屏') }
      ],
      signList: [
        { value: 0, label: this.$t('否') },
        { value: 1, label: this.$t('是') }
      ],
      userList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      uploadLoading: false,
      open: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        theme: null,
        thumb: null,
        sharePic: null,
        liveAddress: null,
        preOpenTime: null,
        liveType: 2,
        screenMode: 1,
        allowUserId: null,
        manageUserId: null,
        isPlayback: 0,
        showSignFlag: 0,
        pubSignNum: 1,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime: 10,
        password: null,
        seekInter: null,
        seekScore: null,
        bitRate: null,
        userShare: null
      },
      rules: {
        theme: [
          { required: true, message: this.$t('直播主题') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: this.$t('直播封面') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getUserList()
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    /** 重置表单为初始值 */
    reset () {
      this.form = {
        id: null,
        theme: null,
        thumb: null,
        sharePic: null,
        liveAddress: null,
        preOpenTime: null,
        liveType: 2,
        screenMode: 1,
        allowUserId: null,
        manageUserId: null,
        isPlayback: 0,
        showSignFlag: 0,
        pubSignNum: 1,
        pubSignTime: 1,
        receiptTime: 1,
        receiptEffectiveTime: 10,
        password: null,
        seekInter: null,
        seekScore: null,
        bitRate: null,
        userShare: null
      }
    },
    parseTime (time) {
      if (!time) return ''
      const date = new Date(time)
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    /** 打开修改弹窗：与新增直播页面布局一致，仅主题/封面可编辑，其余置灰展示 */
    handleEdit (record) {
      this.reset()
      this.getUserList()
      const id = record.id
      getLive({ id }).then(response => {
        const data = response.data || {}
        // 逐个赋值，保持 a-form-model 响应式绑定稳定
        this.form.id = data.id
        this.form.theme = data.theme
        this.form.thumb = data.thumb
        this.form.sharePic = data.sharePic
        this.form.liveAddress = data.liveAddress
        this.form.preOpenTime = data.preOpenTime
        this.form.liveType = data.liveType
        this.form.screenMode = data.screenMode
        this.form.allowUserId = data.allowUserId
        this.form.manageUserId = data.manageUserId
        this.form.isPlayback = Number(data.isPlayback)
        this.form.showSignFlag = Number(data.showSignFlag)
        this.form.pubSignNum = data.pubSignNum
        this.form.pubSignTime = data.pubSignTime
        this.form.receiptTime = data.receiptTime
        this.form.receiptEffectiveTime = data.receiptEffectiveTime
        this.form.password = data.password
        this.form.seekInter = data.seekInter
        this.form.seekScore = data.seekScore
        this.form.bitRate = data.bitRate
        this.form.userShare = data.userShare
        this.open = true
        this.formTitle = this.$t('修改直播')
      })
    },
    getUserList () {
      userList().then(res => {
        this.userList = res.data || []
      })
    },
    /** 提交按钮：仅提交可编辑字段，避免覆盖其他字段 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const params = {
            id: this.form.id,
            theme: this.form.theme,
            thumb: this.form.thumb,
            liveAddress: this.form.liveAddress
          }
          updateLive1(params).then(response => {
            this.$message.success(this.$t('通用.文本.修改成功'), 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
    // oss 上传开始
    beforeOssUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    coverImgUpload(file) {
      const _this = this
      const uploadFile = file.file
      const prefix = 'thumb'
      const url = uploadOss(uploadFile.name, prefix)
      _this.uploadLoading = true
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'thumb', res)
          _this.$message.success(_this.$t('通用.文本.上传成功'))
        }).finally(() => {
          _this.uploadLoading = false
        })
      })
    }
  }
}
</script>
